import React from 'react';

import type { GetListsParams } from '@vlabs/api/luna-api/model';
import { FilterMenuProvider } from '@vlabs/monokit/shared/ui/filter-menu';
import { Page, PageContent } from '@vlabs/monokit/shared/ui/page';
import { PageFilters } from '@vlabs/monokit/shared/ui/page/PageFilters';
import { DEFAULT_PAGE_SIZE } from '@vlabs/uikit/constants';

import { ListListPageFilterMenu } from './filters';
import { ListListPageHeader } from './list-list-page-header/ListListPageHeader';
import { ListListViewer } from './list-list-viewer';
import { ListListPageFiltersProvider } from './useListListPageFilters';

const defaultListListPageFilters: GetListsParams = {
  page: 1,
  page_size: DEFAULT_PAGE_SIZE,
};

interface ListListPageProps {
  title?: string;
  titleItems?: React.ReactNode | React.ReactNode[];
}

export function ListListPage({
  title = undefined,
  titleItems = undefined,
}: ListListPageProps): React.JSX.Element {
  return (
    <Page>
      <ListListPageFiltersProvider initialData={defaultListListPageFilters}>
        <FilterMenuProvider>
          <PageContent>
            <ListListPageHeader
              title={title}
              titleItems={titleItems}
            />
            <ListListViewer />
          </PageContent>

          <PageFilters>
            <ListListPageFilterMenu />
          </PageFilters>
        </FilterMenuProvider>
      </ListListPageFiltersProvider>
    </Page>
  );
}
